import { DtoBase } from '@/types/Dtos/DtoBase'

export class MoveModelDto extends DtoBase {
  constructor(newParentId: string) {
    super({ parentId: newParentId })
  }
}
